import BaseProxy from "../../base-proxy";
import LocalStore from "../../../utilities/local-store-manager";

/**
 * @class PostLogoutUserProxy
 * @description Class used for communicating POST logout requests with user API.
 * @author Aldrev Ven Dayrit
 * @version 1.0
 * @since March 21, 2019
 */
export default class PostLogoutUserProxy {
  /**
   * @async
   * @function execute
   */
  async execute() {
    const baseProxy = new BaseProxy();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/users/logout`;
    const localStore = new LocalStore();
    const authToken = localStore.getToken();
    const userEmail = localStore.getUserEmail();
    const data = {
      email: userEmail,
      authToken: authToken,
    };

    return await baseProxy.postData(endpointUrl, data);
  }
}
